import { StepVariables } from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";

import {
    TOOL_LOGIN_CONTEXT,
    TOOL_LOGIN_STEPS
} from "@/services/tracking/trackers/tools/login/config";
import * as ToolsStepTracker from "@/services/tracking/trackers/tools/toolStep.tracker";
import { createUserId } from "@/services/tracking/trackers/utils";

export const trackStart = () => {
    ToolsStepTracker.track(TOOL_LOGIN_STEPS.start, TOOL_LOGIN_CONTEXT);
};

export const trackSubmit = (loginResult: any) => {
    if (!loginResult) return;

    const customerId = createUserId(loginResult.email);
    const step: StepVariables = {
        ...TOOL_LOGIN_STEPS.submit,
        result: {
            customerid: customerId
        }
    };

    ToolsStepTracker.trackSubmit(step, TOOL_LOGIN_CONTEXT);
};
